module.exports = __webpack_public_path__ + "img/zoom-fly-3-mens-running-shoe-XhzpPH.fc7861b7.png";